import Vue from 'vue'
import attack from '../../../request/request'
import { BASIC } from '../../requers_variable'
import axios from 'axios'

export default {
  /**
   * 饮用水源地新增
   */
  create_water(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/water/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 水源地详情
   */
  detail_water(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/water/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 水源地修改
   */
  modify_water(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/water/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 水源地删除
   */
  delete_water(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/water/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 工业园区新增
   */
  create_zone(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/zone/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 工业园区详情
   */
  detail_zone(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/zone/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 工业园区修改
   */
  modify_zone(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/zone/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   *工业园删除
   */
  delete_zone(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/zone/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 政府新增
   */
  create_gov(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/gov/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 政府详情
   */
  detail_gov(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/gov/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 政府修改
   */
  modify_gov(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/gov/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   *政府删除
   */
  delete_gov(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/gov/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 企业新增
   */
  create_entp(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/entp/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 企业详情
   */
  detail_entp(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/entp/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 企业修改
   */
  modify_entp(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/entp/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   *企业删除
   */
  delete_entp(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/entp/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 其他新增
   */
  create_other(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/other/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 其他详情
   */
  detail_other(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/other/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 修改其他
   */
  modify_other(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/other/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   *其他删除
   */
  delete_other(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/other/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 获取单位列表
   * 
   * @returns 
   */
  get_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/search/client`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 获取单位列表
   * 
   * @returns 
   */
  get_searchlist(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 当前用户申报单位按类型数量
   */
  get_member_count_by_type() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/member/count-by-type`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 图片新增
   */
  img_update(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/img/upload`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  /**
   * 图片显示
   */
  img_get(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/img/get`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 图片删除
   */
  img_delete(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'delete',
        url: `${BASIC}/img/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 树形数据
   */
  get_tree(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/region/tree`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 工业园区列表
   */
  get_zone_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/zone/list`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 新增企业选择行业
  industry_tree(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/industry/tree`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/basic/plan/company.js